import React from "react";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Style from "style-it";
import { visibleTabs } from "./tabConfig";

const tabClasses = {
  root: "custom-tab-button2",
  selected: "custom-tab-button-selected2",
};

const DetailTabs = ({
  value,
  onChange,
  tabs,
  translate,
  themecolors,
  children,
  paperStyle,
}) => {
  const orientation = window.innerWidth <= 959 ? "horizontal" : "vertical";
  const items = visibleTabs(tabs);
  return (
    <>
      <Style>{`
        .tab-vertial-wrapper > .custom-tabs {
          background: ${themecolors?.backgroundColor || "transparent"};
        }
        .custom-tab-button2 .MuiTab-wrapper {
          align-items: normal;
          flex-direction: row;
          justify-content: unset;
        }
        .custom-tab-button2 {
          color: ${themecolors?.textColor || "inherit"};
          text-align: left;
          text-transform: inherit;
          border-bottom: 1px solid rgba(0,0,0,0.05);
        }
        .custom-tab-button {
          min-height: 29px;
          border-radius: 6px 6px 0 0;
          margin: 0 2px;
        }
        .custom-tabs {
          min-height: 30px;
          margin: 10px 6px 0;
        }
        .custom-tab-button-selected2 {
          color: ${themecolors?.["500"] || "inherit"};
        }
        .Mui-selected {
          color: ${themecolors?.["500"] || "inherit"} !important;
        }
      `}</Style>
      <div className="v-tabs">
        <AppBar
          elevation={0}
          position="static"
          style={{ background: "transparent" }}
          className="tab-vertial-wrapper"
        >
          <Tabs
            value={value}
            onChange={onChange}
            orientation={orientation}
            classes={{ root: "custom-tabs" }}
            TabIndicatorProps={{ style: { background: "transparent" } }}
            style={{ background: "#fff" }}
          >
            {items.map((tab) => (
              <Tab
                key={tab.value}
                value={tab.value}
                classes={tabClasses}
                style={{ alignItems: "flex-start" }}
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <KeyboardArrowRightIcon style={{ margin: "0 8px" }} />
                    {translate(tab.labelKey)}
                  </div>
                }
              />
            ))}
          </Tabs>
          <Paper
            style={{ padding: 16, minHeight: 270, flex: 1, ...paperStyle }}
            square
          >
            {children}
          </Paper>
        </AppBar>
      </div>
    </>
  );
};

export default DetailTabs;
